import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, PRIMARY_OUTLET, Router } from '@angular/router';
import { ActivityData } from '../activity-data';
import { find } from 'lodash';
import { NavigationActivityResolverData } from './navigation-activity-resolver';

@Injectable()
export class NavigationActivity {

    constructor(private readonly router: Router) { }

    public getNavigationActivity(): ActivityData | null {
        const activatedRoute = this.getActivatedRoute();

        if (!activatedRoute) {
            return null;
        }

        const activityData = this.findNavigationActivityData(activatedRoute);

        return activityData;
    }

    private getActivatedRoute(): ActivatedRouteSnapshot {
        const global = find(this.router.routerState.snapshot.root.children, rs => rs.outlet === 'global-popup');

        if (global) {
            return global;
        }

        const primary = find(this.router.routerState.snapshot.root.children, rs => rs.outlet === PRIMARY_OUTLET);

        return primary;
    }

    private findNavigationActivityData(activatedRoute: ActivatedRouteSnapshot): ActivityData {
        const activityKey: keyof NavigationActivityResolverData = 'activity';
        let activityData: ActivityData = null;
        let route = activatedRoute;

        while (route) {
            if (route.data && route.data[activityKey]) {
                activityData = route.data[activityKey];
            }

            route = route.firstChild;
        }

        return activityData;
    }
}